import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import ValueLink from 'sb-valuelink'
import NativeListener from 'react-native-listener'
import { intlMessageShape } from 'sb-react-intl'

import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import Input from 'components/forms/Input/Input'

import s from './SelectizeView.scss'


class SelectizeView extends Component {

  static propTypes = {
    className: PropTypes.string,
    inputValue: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape(intlMessageShape),
      ]),
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    })),
    optionRender: PropTypes.func,
    placeholder: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape(intlMessageShape),
    ]),
    error: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape(intlMessageShape),
    ]),
    inputId: PropTypes.string,
    optionsId: PropTypes.string,
    withMagnifierIcon: PropTypes.bool,
    withLoader: PropTypes.bool,
  }

  static defaultProps = {
    options: [],
  }

  static contextTypes = {
    selectize: PropTypes.object,
  }

  state = {
    areOptionsVisible: false,
  }

  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick)
  }

  handleDocumentClick = () => {
    this.hideOptions()
  }

  hideOptions = () => {
    const { areOptionsVisible } = this.state

    if (areOptionsVisible) {
      this.setState({
        areOptionsVisible: false,
      })
    }
  }

  handleClearButtonClick = () => {
    const { selectize: { onChange, onSelect } } = this.context

    onChange('')
    onSelect({ value: '', title: '' })
  }

  handleInputClick = (event) => {
    event.stopPropagation()
  }

  handleInputFocus = () => {
    this.setState({
      areOptionsVisible: true,
    })
  }

  handleInputTouchStart = () => {

  }

  handleInputChange = (inputValue) => {
    const { selectize: { onChange } } = this.context

    onChange(inputValue)
  }

  handleOptionsClick = (event) => {
    event.stopPropagation()
  }

  handleOptionClick = (option) => {
    const { selectize: { onSelect } } = this.context

    this.setState({
      areOptionsVisible: false,
    }, () => {
      onSelect(option)
    })
  }

  render() {
    const { areOptionsVisible: _areOptionsVisible } = this.state
    const {
      className, inputValue, placeholder, error, options, optionRender,
      withMagnifierIcon, withLoader,
      inputId, optionsId,
    } = this.props

    const linkedInputValue      = ValueLink.value(inputValue, this.handleInputChange)
    const isClearButtonVisible  = Boolean(inputValue)
    const areOptionsVisible     = Boolean(_areOptionsVisible && options.length)

    if (error) {
      linkedInputValue.error = error
    }

    return (
      <div className={cx(s.selectize, className)} data-testid={optionsId}>
        {
          isClearButtonVisible && (
            <CloseIcon className={s.clearButton} onClick={this.handleClearButtonClick} />
          )
        }
        <NativeListener onClick={this.handleInputClick}>
          <Input
            id={inputId}
            inputClassName={s.input}
            placeholder={placeholder}
            onFocus={this.handleInputFocus}
            valueLink={linkedInputValue}
            withLoader={withLoader}
            withMagnifierIcon={withMagnifierIcon}
            onTouchStart={this.handleInputTouchStart}
          />
        </NativeListener>
        {
          areOptionsVisible && (
            <div className={s.options} data-testid={optionsId} onClick={this.handleOptionsClick}>
              {
                options.map((option) => {
                  const { value, title } = option

                  return (
                    <div key={value} className={s.option} onClick={() => this.handleOptionClick(option)}>
                      {
                        optionRender ? optionRender(option, inputValue) : title
                      }
                    </div>
                  )
                })
              }
            </div>
          )
        }
      </div>
    )
  }
}


export default SelectizeView
